import "@/App.css";
import "./pages/leaflet.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Leaflet from "./pages/Leaflet";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/leaflet" element={<Leaflet />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
